import { render, staticRenderFns } from "./MediaDemoBlock.vue?vue&type=template&id=4a122e0f"
import script from "./MediaDemoBlock.vue?vue&type=script&lang=js"
export * from "./MediaDemoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports